<div class="footer">
    <div class="heading">
    </div>
    <div class="content">
        <div class="logo">
            <p><img src="assets/astrazeneca_logo_white.png" class="footer-title"></p>
        </div>
        <div class="full-text">
            <p class="tag-align">
                {{footerTag}}
            </p>
        </div>
        <div class="short-text">
            <p class="tag-align">
                {{'msg#footer.shortTag' | sqMessage}}
            </p>
        </div>
        <div class="links">
            <p class="symbol">&copy;{{symbol}}</p>
        </div>
    </div>
</div>